import React, { useRef, useState, useLayoutEffect } from 'react';
import { Tooltip, Box } from '@mui/material';

const OverflowTooltip = ({ children, title, maxWidth = '200px' }) => {
  const ref = useRef(null);
  const [isOverflow, setIsOverflow] = useState(false);

  const check = () => {
    const el = ref.current;
    if (!el) return;
    setIsOverflow(el.scrollWidth > el.clientWidth + 1);
  };

  useLayoutEffect(() => {
    check();
    let ro;
    if (typeof ResizeObserver !== 'undefined') {
      ro = new ResizeObserver(check);
      if (ref.current) ro.observe(ref.current);
    } else {
      window.addEventListener('resize', check);
      window.addEventListener('load', check);
    }
    const rafId = requestAnimationFrame(check);

    return () => {
      if (ro) ro.disconnect();
      else {
        window.removeEventListener('resize', check);
        window.removeEventListener('load', check);
      }
      cancelAnimationFrame(rafId);
    };
  }, [title]);

  const content = (
    <Box
      ref={ref}
      sx={{
        maxWidth,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        display: 'block',
      }}
    >
      {children}
    </Box>
  );

  return isOverflow ? (
    <Tooltip
      title={typeof title === 'string' || typeof title === 'number' ? String(title) : ''}
      arrow
      placement="bottom"
      componentsProps={{
        tooltip: { sx: { bgcolor: '#4D4D4D', color: '#ffffff', px: 1.5, py: 0.5, borderRadius: '6px', fontSize: '0.8125rem' } },
        arrow: { sx: { color: '#4D4D4D' } },
      }}
    >
      {content}
    </Tooltip>
  ) : (
    content
  );
};

export default OverflowTooltip;